import type { MediaItem } from "@/modules/common/media/mediaTypes"
import { ScoreSetCompletionEntity } from "@/modules/scores/scoreForms/entities/scoreSetCompletionEntity"
import type { ScoreDifficultyEnum, TieBreak } from "@/modules/scores/scoreTypes"
import type { ScoreboardScoreDto } from "@/modules/scores/scoreboard/gateway/scoreboardDto"

export class ExerciseScoreEntity {
  valueDecimal: number | null
  additionalValueDecimal: number | null
  difficulty: ScoreDifficultyEnum | null
  note: string | null
  noteAndMediaIsVisible: boolean | null
  medias: MediaItem[] | null
  timeCapExceeded: boolean | null
  tieBreaks: TieBreak[] | null
  scoreSetCompletions: ScoreSetCompletionEntity[] | null
  personalRecord: boolean | null
  reps: number | null

  constructor(exerciseScore: ExerciseScoreEntity) {
    this.valueDecimal = exerciseScore.valueDecimal
    this.additionalValueDecimal = exerciseScore.additionalValueDecimal
    this.difficulty = exerciseScore.difficulty
    this.note = exerciseScore.note
    this.noteAndMediaIsVisible = exerciseScore.noteAndMediaIsVisible
    this.medias = exerciseScore.medias
    this.timeCapExceeded = exerciseScore.timeCapExceeded
    this.tieBreaks = exerciseScore.tieBreaks
    this.scoreSetCompletions = exerciseScore.scoreSetCompletions
    this.personalRecord = exerciseScore.personalRecord
    this.reps = exerciseScore.reps
  }

  static fromDto(dto: ScoreboardScoreDto): ExerciseScoreEntity {
    return new ExerciseScoreEntity({
      valueDecimal: dto.valueDecimal,
      additionalValueDecimal: dto.additionalValueDecimal,
      difficulty: dto.difficulty,
      note: dto.note,
      noteAndMediaIsVisible: dto.noteAndMediaIsVisible,
      medias: dto.medias,
      timeCapExceeded: dto.timeCapExceeded,
      tieBreaks: dto.tieBreaks,
      scoreSetCompletions:
        dto.scoreSetCompletions?.map((scoreSetCompletion) => ScoreSetCompletionEntity.fromDto(scoreSetCompletion)) ??
        null,
      personalRecord: dto.personalRecord,
      reps: dto.reps,
    })
  }
}
